module.exports = __webpack_public_path__ + "assets/img/汉玺牛肉.8bd50b75.png";